import { useMutation, useQueryClient } from "@tanstack/react-query";
import myAxios from "@/utilize/MyAxios.ts";

export default function useUpdateRoleDetails() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (
      payload: Record<"name" | "description" | "currentName", string>,
    ) =>
      myAxios
        .patch(`acl/custom-role`, {
          name: payload.name,
          description: payload.description,
          currentName: payload.currentName,
        })
        .then((res) => res.data),
    onSuccess(_, variables) {
      queryClient.resetQueries({
        queryKey: ["permissionsRoles", variables.currentName],
      });
    },
  });
}
